import { render, staticRenderFns } from "./CopyDocumentToCollections.vue?vue&type=template&id=94fd9f56&scoped=true"
import script from "./CopyDocumentToCollections.vue?vue&type=script&lang=js"
export * from "./CopyDocumentToCollections.vue?vue&type=script&lang=js"
import style0 from "./CopyDocumentToCollections.vue?vue&type=style&index=0&id=94fd9f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fd9f56",
  null
  
)

export default component.exports